import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import TitleDetail from "@/pages/TitleDetail";
import Watch from "@/pages/Watch";
import Awards from "@/pages/Awards";
import Submit from "@/pages/Submit";
import Browse from "@/pages/Browse";
import About from "@/pages/About";
import Advertise from "@/pages/Advertise";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

function App() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col">
      {!isAdmin && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/movies" element={<Browse initialType="movie" />} />
          <Route path="/shows" element={<Browse initialType="series" />} />
          <Route path="/originals" element={<Browse initialType="original" />} />
          <Route path="/kids" element={<Browse initialType="kids" />} />
          <Route path="/live" element={<Browse initialType="live" />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/about" element={<About />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/title/:slug" element={<TitleDetail />} />
          <Route path="/watch/:slug" element={<Watch />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

export default App;
